import { HistoryDayDTO } from "../../HubSpot/useGetHubSpotCloserAvailabilityHistory.ts";
import { dayLabel } from "./closerAvailabilityHistoryStats.ts";
import {
  DeltaCell,
  SaturationCell,
  tdClass,
  thClass,
  thLeftClass,
  tdLeftClass,
} from "./HistoryCells.tsx";

type Props = {
  days: HistoryDayDTO[];
  hasClosure: boolean;
  comparable: boolean;
};

export function HistoryDayTable({ days, hasClosure, comparable }: Props) {
  const visibleDays = days.filter((d) => d.opening || d.closure);
  if (visibleDays.length === 0) {
    return <p className="text-sm text-gray-400">Nessun dato disponibile.</p>;
  }

  const total = visibleDays.reduce(
    (acc, d) => ({
      opening: acc.opening + (d.opening?.effective ?? 0),
      closure: acc.closure + (d.closure?.effective ?? 0),
      calls: acc.calls + (d.closure?.inCall ?? 0),
      ooo: acc.ooo + (d.closure?.ooo ?? 0),
    }),
    { opening: 0, closure: 0, calls: 0, ooo: 0 },
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[640px] border-collapse">
        <thead>
          <tr>
            <th className={thLeftClass}>Giorno</th>
            <th className={thClass}>Capacity apertura</th>
            <th className={thClass}>Slot effettivi</th>
            <th className={thClass}>Δ</th>
            <th className={thClass}>Call</th>
            <th className={thClass}>Slot OOO</th>
            <th className={thClass}>Saturazione</th>
          </tr>
        </thead>
        <tbody>
          {visibleDays.map((d) => (
            <tr key={d.date}>
              <td className={`${tdLeftClass} font-semibold`}>
                {dayLabel(d.date)}
              </td>
              <td className={tdClass}>{d.opening?.effective ?? "—"}</td>
              <td className={tdClass}>
                {hasClosure ? (d.closure?.effective ?? "—") : "—"}
              </td>
              <DeltaCell
                value={
                  comparable
                    ? (d.closure?.effective ?? 0) - (d.opening?.effective ?? 0)
                    : null
                }
              />
              <td className={tdClass}>{d.closure?.inCall ?? "—"}</td>
              <td className={tdClass}>{d.closure?.ooo ?? "—"}</td>
              <SaturationCell
                calls={d.closure?.inCall ?? 0}
                effective={d.closure?.effective ?? 0}
              />
            </tr>
          ))}
          <tr className="bg-slate-50 font-semibold">
            <td className={tdLeftClass}>Totale</td>
            <td className={tdClass}>{total.opening}</td>
            <td className={tdClass}>{hasClosure ? total.closure : "—"}</td>
            <DeltaCell
              value={comparable ? total.closure - total.opening : null}
            />
            <td className={tdClass}>{total.calls}</td>
            <td className={tdClass}>{total.ooo}</td>
            <SaturationCell calls={total.calls} effective={total.closure} />
          </tr>
        </tbody>
      </table>
    </div>
  );
}
